import request from "@/utils/request";

export const GetcouponQRCode = data => {
  return request({
    url: "/venue/Fee/couponQRCode",
    method: "POST",
    data
  });
};

export const GetcouponPublic = data => {
  return request({
    url: "/venue/Fee/couponPublic",
    method: "POST",
    data
  });
};
